import { mixpanel } from '@fiverr-private/obs';
import store from '../../store';
import { getCardEnrichment, LogoPayload } from '../../utils';

/**
 * The user clicked on a logo
 */
export const reportLogoClicked = (logoPayload: LogoPayload) => {
    mixpanel.track('Logo Maker - MPI - Logo Clicked', {
        ...store.brief.getData(),
        ...store.user.getData(),
        ...store.listingsType.getData(),
        ...getCardEnrichment(logoPayload),
    });
};
